import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"arrow-down\"><path d=\"M5 12.01V0H3v12.01H0L4 16l4-3.99z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol